export interface MedSummaryData {
  version_id: string;
  case_id: string;
  patient_name: string | null;
  date_of_birth: string | null;
  date_of_injury: string | null;
  accident_description: string | null;
  key_injuries: string | null;
  key_test_results: string | null;
  key_diagnoses: string | null;
}

/** Fields edited in the medical chronology summary tab and accepted by summary PATCH (excludes ids). */
export type MedSummaryDraftFields = Pick<
  MedSummaryData,
  | "patient_name"
  | "date_of_birth"
  | "date_of_injury"
  | "accident_description"
  | "key_injuries"
  | "key_test_results"
  | "key_diagnoses"
>;

/** Keys for all editable medical summary fields in chronology diffs (single source of truth). */
export const MED_SUMMARY_FIELD_KEYS: (keyof MedSummaryData)[] = [
  "patient_name",
  "date_of_birth",
  "date_of_injury",
  "accident_description",
  "key_injuries",
  "key_test_results",
  "key_diagnoses",
];

/** Keys for clinical highlights on the chronology summary tab (single source of truth). */
export const MED_SUMMARY_CLINICAL_HIGHLIGHT_FIELD_KEYS = [
  "key_injuries",
  "key_test_results",
  "key_diagnoses",
] as const;

export type MedSummaryDataUpdate = Partial<MedSummaryDraftFields>;
